<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600">
    <ValidationObserver ref="obs">
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Eliminar Registro
            </v-card-title>
          </v-img>
        </v-card-title>

        <v-card-text style="max-height: 350px">
          <v-form>
            <v-row dense>
              <v-col cols="12">
                <v-card-title class="font-weight-medium ">
                  Esta seguro que desea eliminar este Registro?
                </v-card-title>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
          </v-hover>
          <v-spacer></v-spacer>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="error"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="deleteAction()"
            >
              Eliminar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    id: {
      type: Number,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    closeDialog(data = false) {
      this.$emit("dialog:close", data);
    },
    async deleteAction() {
      this.loading = true;
      try {
        await PbxHttpClient.delete(`/admin/directory/${this.id}`);
        this.closeDialog(this.id);
        this.$snotify.success("Registro eliminado con exito", "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo eliminar el registro.", "¡Error!");
      }
      this.loading = false;
    },
  },
};
</script>

<style></style>
